import { render, staticRenderFns } from "./GoodsSeckill.vue?vue&type=template&id=1270433c&scoped=true"
import script from "./GoodsSeckill.vue?vue&type=script&lang=js"
export * from "./GoodsSeckill.vue?vue&type=script&lang=js"
import style0 from "./GoodsSeckill.vue?vue&type=style&index=0&id=1270433c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270433c",
  null
  
)

export default component.exports